import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SaveSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 18 18",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.5603 4.50001L13.5 0.439695C13.3612 0.299801 13.196 0.188889 13.014 0.113407C12.832 0.0379245 12.6367 -0.000621974 12.4397 7.58902e-06H1.5C1.10218 7.58902e-06 0.720644 0.158043 0.43934 0.439347C0.158035 0.720652 0 1.10218 0 1.50001V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V5.56032C18.0006 5.36326 17.9621 5.16805 17.8866 4.98602C17.8111 4.804 17.7002 4.63879 17.5603 4.50001ZM12.75 16.5H5.25V11.25H12.75V16.5ZM16.5 16.5H14.25V11.25C14.25 10.8522 14.092 10.4707 13.8107 10.1893C13.5294 9.90804 13.1478 9.75001 12.75 9.75001H5.25C4.85218 9.75001 4.47064 9.90804 4.18934 10.1893C3.90804 10.4707 3.75 10.8522 3.75 11.25V16.5H1.5V1.50001H12.4397L16.5 5.56032V16.5ZM12 3.75001C12 3.94892 11.921 4.13969 11.7803 4.28034C11.6397 4.42099 11.4489 4.50001 11.25 4.50001H6C5.80109 4.50001 5.61032 4.42099 5.46967 4.28034C5.32902 4.13969 5.25 3.94892 5.25 3.75001C5.25 3.5511 5.32902 3.36033 5.46967 3.21968C5.61032 3.07903 5.80109 3.00001 6 3.00001H11.25C11.4489 3.00001 11.6397 3.07903 11.7803 3.21968C11.921 3.36033 12 3.5511 12 3.75001Z"
        fill="#1F2647"
      />
    </svg>
  );
};

export { SaveSvg };
